<script lang="ts">
  import BetaTag from './BetaTag.svelte';
  import { demoActive, demoUsage } from '../lib/demoMode';

  const ratio = $derived($demoUsage.cap ? $demoUsage.used / $demoUsage.cap : 0);
  function fmtK(n: number): string {
    if (n >= 1000) { const k = n / 1000; return (k >= 100 ? String(Math.round(k)) : k.toFixed(1).replace(/\.0$/, '')) + 'k'; }
    return String(Math.round(n));
  }
</script>

<footer class="footer" class:demo={$demoActive}>
  <span class="brand">empowered</span>
  {#if $demoActive}
    <span class="demo-tag">Demo product</span>
    <span
      class="demo-usage"
      class:warn={ratio >= 0.8 && ratio < 1}
      class:over={ratio >= 1}
      title="Assistant tokens used on this demo key. When it reaches the limit, the team can reset your key."
    >{fmtK($demoUsage.used)} / {fmtK($demoUsage.cap)} tokens</span>
  {:else}
    <BetaTag />
    <span class="faint">&nbsp;brought to you by DREAM Gigafactories Corporation</span>
  {/if}
</footer>

<style>
  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--space-2);
    padding: var(--space-2) var(--space-4) calc(var(--safe-bottom) + var(--space-2));
    background: var(--bg);
    border-top: 1px solid var(--line);
    font-size: var(--fs-2xs);
    letter-spacing: 0.06em;
    color: var(--text-3);
    white-space: nowrap;
  }
  .brand { font-family: var(--font-brand); font-weight: 400; color: var(--text-2); }
  /* In the demo, tint the wordmark with the demo (blue) accent and swap the beta tag
     for a "Demo product" pill + a live per-key assistant-token counter. */
  .footer.demo { border-top-color: var(--accent-soft); }
  .footer.demo .brand {
    background: var(--accent-grad-text); -webkit-background-clip: text; background-clip: text; color: transparent;
  }
  .demo-tag {
    font-weight: 700; letter-spacing: 0.10em; text-transform: uppercase;
    background: var(--accent-grad); color: var(--on-accent);
    border-radius: var(--radius-pill); padding: 1px var(--space-2);
  }
  .demo-usage { font-variant-numeric: tabular-nums; letter-spacing: 0.02em; color: var(--text-2); }
  .demo-usage.warn { color: var(--warn); }
  .demo-usage.over { color: var(--danger); font-weight: 700; }
</style>
